import React, { useEffect, useState } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  applicationListAction, updateApplicationAction, ConfigApplicaitonTemplate
} from "../../../redux/actions/ApplicationActions";
import SimpleMenu from "../../layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../../logo.png";
import { RegisterAction } from "../../../redux/actions/AuthActions";
import * as ActionTypes from "../../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import Geographical from "../../../constants/Geographical.json";
import 'react-phone-input-2/lib/material.css';
import parse from 'html-react-parser';
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
export default function ApplicationsListPanel(props) {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const applicationsListResponse = useSelector((state) => state.applicationsInfo.applicationsList);
  const [searched, setSearched] = useState("");
  const [applicationTypes, setApplicationTypes] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("all");
  const [searchKeyValue, setSearchKeyValue] = useState("");
  const [applicationTypeKey, setApplicationTypeKey] = React.useState("all");
  const [applicationTypeKeyAssist, setApplicationTypeKeyAssist] = React.useState("all");
  const [restrictedStatus, setRestrictedStatus] = useState(false);
  const [restrictedResponse, setRestrictedResponse] = useState("");
  const [bodyStatus, setBodyStatus] = useState(false);
  const [applications, setApplications] = useState(false);
  const [tableConfig, setTableConnfig] = useState("");
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [open, setOpen] = React.useState(false);
  const [assignOpen, setAssignOpen] = React.useState(false);
   
  const [fields, setState] = useState({
    name: "",
    company_id: "",
    client_id:"",
    created_by_id: "",
    application_template_id:"",
    id: null,
    status: false
  });
  const labelList = {
    all: "All",
    name: "Name",
    company_id: "Company",
    client_id:"Representative",
    created_by_id: "Created By",
    // application_template_id:"Application Type",
    status: "Status",
  };
  const columns = [
    { field: "id", headerName: "ID", width: 100, cellClassName: "cell_class_name" },
    { field: "name", headerName: "Project Title", width: 190, cellClassName: "cell_class_name" },
    { field: "application_template_id", headerName: "Type", width: 190, cellClassName: "cell_class_name" },
    
    { field: "company_id", headerName: "Company Name", width: 130, cellClassName: "cell_class_name" },
    { field: "client_id", headerName: "Representative", width: 130, cellClassName: "cell_class_name" },
    { field: "created_by_id", headerName: "Created By", width: 130, cellClassName: "cell_class_name" },
    { field: "status", headerName: "Status", width: 130 },
    { field: "actions", headerName: "Actions", width: 130 },
  
  ];
  const getDistrictName = (company) => {

    Geographical.map((option) => {
      if (option.id == company.company_province) {
        company.company_province = option.name;
        option.districts.map((district, index) => {
          if (district.id == company.company_district) {

            company.company_district = district.name;
            district.municipalities.map((city, key) => {
              if (city.id == company.company_city) {
                company.company_city = city.name
                city.wards.map((ward, key) => {
                  if (ward == company.company_ward) {
                    company.company_ward = ward;
                  }

                }) /*ward mapping not needed just done for fun */
              }
            })
          }
        })
      }
    })
    // company.company_province = company.company_province + '<br/>' + company.company_district + '<br/>' + company.company_city + '<br/>' + company.company_ward
    return company;
  }
  const assignUser = (event, row) => {
    setState({
      ...fields,
      name: row.name,
      company_id: row.company.name_of_company,
      created_by_id: row.created_by_id,
      id: row.id,

      status: row.status
    });

    dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });


    setAssignOpen(true);
  }
  const editUser = (event, row) => {
   


    setState({
      ...fields,
      name: row.name,
      company_id: row.company.name_of_company,
      created_by_id: row.created_by_id,
      id: row.id,
     
      status: row.status
    });


   
    dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });


    setOpen(true);
  };
  const deleteUser = (event, param) => {
    event.stopPropagation();
    //dispatch(CustomerDeleteAction(param.row, history));
  };
  const requestSearch = (searchedVal) => {

    applications.map((element) => (
      element.status = (element.status === null || element.status === 0) ? "Inactive" : "Active"

    ))
    applications.map((element) => (
      element = getDistrictName(element)
    ))
    setSearchKeyValue(searchedVal);
    setPage(0);
    


    dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, 
      getDistrictName, setRows, setApplications, setTableConnfig, 0,
       page, rowsPerPage, applicationTypeKey, searchKey, searchedVal));
  };
  const handleSearchKey = (e) => {
    const { name, value } = e.target;
    setSearchKey(value);



  };
  const handleApplicationTypeKey = (e) => {
    const { name, value } = e.target;
    setApplicationTypeKey(value);
    setApplicationTypeKeyAssist(value);
    setPage(0);
    dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus,
       getDistrictName, setRows, setApplications, setTableConnfig, 
       0, 0, rowsPerPage, value, searchKey, searchKeyValue));


  };
  const handleAssignmentClose = () => {
    
    dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });
    setState({
      ...fields,
      name: "",
      company_id: "",
      client_id: "",
      created_by_id: "",
      application_template_id: "",

      id: null,
      changeStatus: false,
      fieldStatus: false,
      status: false
    });
    setAssignOpen(false);
  }

  const handleClose = () => {
    
    dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });
    if (fields.changeStatus) {
      //to refresh the page 
      //dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, 1, rowsPerPage, applicationTypeKey))
    }
    setState({
      ...fields,
      name: "",
      company_id: "",
      client_id:"",
      created_by_id: "",
      application_template_id: "",
      renderStatus: true,
      id: null,
      changeStatus: false,
      fieldStatus: false,
      status: false
    });
    setOpen(false);
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };




  /*Edit User Functionalities Section */

  const handleFieldChange = (e) => {

    setState({
      ...fields,
      changeStatus: true,

      fieldStatus: false,
      [e.target.name]: e.target.value,
    });

  };


  const handleFieldChangeRadio = (e) => {
    setState({
      ...fields, changeStatus: true,
      fieldStatus: false,
      [e.target.name]: e.target.value,
    })

  }

  const handleFieldChangePhone = (value) => {
   
    if (fields['contact_no'] != value) {
      
      setState({
        ...fields, changeStatus: true,
        fieldStatus: false,
        'contact_no': value,
      })
    }
  }


  const UpdateApplication = (e) => {

    e.preventDefault();
   
    let temp_object = {
      ...fields
    };


    dispatch(updateApplicationAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications));

    setState({
      ...fields,
      fieldStatus: true,
    });
  };
  const UpdateStatusApplication = (e) => {

    e.preventDefault();
   

    let temp_object = {
      ...fields,
      status: 'pending',
      changeStatus: true, // for backend update control and refersh if needed
    };


    dispatch(updateApplicationAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications));

    setState({
      ...fields,
      fieldStatus: true, // for message display
      status: 'pending'
    });

  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, 
      getDistrictName, setRows, setApplications, setTableConnfig,
       0, newPage, rowsPerPage, applicationTypeKey, searchKey, searchKeyValue));
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    //dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, page, event.target.value, applicationTypeKey));
    dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, page, event.target.value, applicationTypeKey, searchKey, searchKeyValue));
 };


  /*End of Edit User Functionalities Section */
  useEffect(() => {
    let customer_id = parseInt(history.location.pathname.replace('/customer-details/', ''));

    customer_id = isNaN(customer_id) ? 0 : customer_id;
    ConfigApplicaitonTemplate().then(res => {

      setApplicationTypes(res.data);

    });
    dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, customer_id, page, rowsPerPage, applicationTypeKey));

    return () => { };
  }, [fields.renderStatus == true]);
  return (
    <>
      <div className={classes.root}>
        {restrictedStatus &&
          <> <Grid container className={classes.bodyWrapper}>
            <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

            </Grid>
          </Grid>
          </>
        }
        {!restrictedStatus && bodyStatus &&
          <Grid container >

            

            <Grid xs={12} md={12} className={classes.rightSideContent} style={{ marginTop: "25px" }}>
              <Typography variant="h6" component="div" style={{ position: "relative", textAlign: "left", marginBottom: "15px" }} gutterBottom>
                List of Applications
              </Typography>
              <Grid container item xs={10} style={{ marginBottom: "25px" }}>
                <Grid item xs={3} className={classes.searchBox}>
                  <SearchBar
                    value={searched}
                    onChange={(searchVal) => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                  />
                </Grid>
              
                <Grid item xs={3}>
                  <FormControl variant="outlined" className={classes.formControl}>

                    <InputLabel>Application Type</InputLabel>
                    <Select
                      name="search_application_type"
                      label={"Search Type"}
                      value={applicationTypeKey}
                      onChange={handleApplicationTypeKey}

                    > <MenuItem key="all" value="all" xyz="all">
                        All
                      </MenuItem>

                      {applicationTypes.map((item) => {

                        return <MenuItem key={item.id} value={item.id} xyz={item.name}>
                          {item.name}
                        </MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>


              </Grid>
              <Grid container item xs={12}>
                <Grid xs={12}>
                  <div className={classes.MuiDataGrid_windowContainer}>

                    {applications.length !== 0 ? (
                      <>
                        <TableContainer className={classes.container}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                {columns.map((column) => {
                                  if (column.field.localeCompare("actions")) {


                                    return (<TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{ minWidth: column.minWidth }}
                                    >
                                      {column.headerName}
                                    </TableCell>)
                                  } else {
                                    return (<TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{ minWidth: column.minWidth }}
                                    >
                                      {column.headerName}
                                    </TableCell>)
                                  }
                                })
                                }

                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row, index) => {
                                return (
                                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    {columns.map((column) => {
                                      const value = row[column.field];
                                      
                                      if (!column.field.localeCompare("actions")) {
                                        return (<TableCell key={column.field}>
                                          <div
                                            style={{
                                              textAlign: "center",
                                              paddingLeft: "15px",
                                              paddingRight: "15px",
                                            }}
                                            key={column.field}
                                          >
                                            {(row['status'] == "draft" || row['status'] == "intermediate") &&
                                              <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                editUser(event, row);
                                              }}>Modify</Button></span>}
                                            {(row['status'] == "draft" || row['status'] == "intermediate")
                                            && <span>
                                              <br/>
                                              <Button variant="outlined" size="large" style={{ backgroundColor: "#67a8e4", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                assignUser(event, row);
                                              }}>
                                                Submit
                                              </Button></span>}
                                            {row['status'] == "pending" && <span style={{ color: "red" }}>Your application is in pending state.This is system autogenerated remark.</span>}
                                            {row['status'] == "processing" && <span style={{ color: "blue" }}> <br />Processing:Your Application is in under the review.</span>}
                                            {row['status'] == "cancelled" && <span style={{ color: "red" }}><br />
                                             Application has been cancelled.</span>}
                                            {row['status'] == "completed" && <span style={{ color: "green" }}><br />Your applicaiton has been approved.</span>}
                                            {row['status'] == "intermediate" && <span style={{ color: "green" }}><br />Rarely DOED provides this status for the correction of documents and wrong informations if any.</span>}
                                          </div>

                                        </TableCell>)
                                      } else {
                                        return (
                                          <TableCell key={column.field} >
                                            {row['status'] == "cancelled" && column.field == "status" && <span style={{ color: "red" }}>
                                              <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(185 32 52)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                              Cancelled
                                              </Button>
                                            </span>}
                                            {row['status'] == "draft" && column.field == "status"
                                             && 
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14x" }}>
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(74 24 0)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Draft</Button></span>
                                            }
                                            {row['status'] == "pending" && column.field == "status"
                                             && 
                                             
                                              <span style={{ fontSize: "bold", color: "#234206", fontSize: "14px" }}><Button variant="outlined" size="small" style={{ backgroundColor: "rgb(16 100 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                Pending</Button></span>
                                             }
                                            {row['status'] == "processing" && column.field == "status" && 
                                              <span style={{ fontSize: "bold", color: "#3f51b5", fontSize: "14px" }}>  <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(126 83 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                In progress</Button></span> 
                                            }
                                            {row['status'] == "completed" && column.field == "status" && 
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}> 
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(78 143 20)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Completed</Button></span> 
                                            }
                                            {row['status'] == "intermediate" && column.field == "status" &&
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}>
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(153 167 38)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Completed</Button></span>
                                            }
                                            {column.field != "status" && value}

                                          </TableCell>
                                        );
                                      }
                                    })}
                                    {



                                    }

                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 100]}
                          component="div"
                          count={tableConfig.total}
                          rowsPerPage={tableConfig.per_page}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </>
                    ) : (
                      <div className={classes.beforeLoad}>
                          
                         
                          <span>Displaying Applications List...</span> 
                          <br/>
                            {applicationsListResponse.hasOwnProperty('extra') && applicationsListResponse.success &&
                              applicationsListResponse.message
                            
                           
                            }
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
              <div>
                <Dialog
                  onClose={handleClose}
                  aria-labelledby="customized-dialog-title"
                  open={open}
                  fullWidth
                  maxWidth="lg"
                >
                  <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <b
                      className={classes.primary}
                      style={{ textAlign: "center" }}
                    >
                      Edit Application
                    </b>
                  </DialogTitle>
                  <DialogContent dividers>
                    {applicationsListResponse.success == false &&
                      applicationsListResponse.updatedUser != "" &&
                      fields.fieldStatus == true &&
                      <div className={classes.customFail}>
                        {applicationsListResponse.message}
                      </div>

                    }

                    {
                      applicationsListResponse.success == true &&
                      applicationsListResponse.updatedUser != "" &&
                      fields.fieldStatus == true &&
                      <div className={classes.customSuccess}>
                        {applicationsListResponse.message}
                      </div>

                    }
                   
                    <form >
                      <Grid container item xs={12}>
                        <Grid item xs={6}>
                          <TextField
                            type="text"
                            className={classes.fullWidth}
                            required
                            margin="normal"
                            variant="outlined"
                            label="Project Title"
                            id="name"
                            name="name"
                            value={fields.name}
                            onChange={handleFieldChange}
                          />
                          <br />
                          {fields.name == "" && <span style={{ color: "red" }}> Project title must not be empty.</span>}
                        </Grid>

                        {/* <Grid item xs={6}>
                          <FormControl>
                            <FormLabel>Application Status</FormLabel>
                            <RadioGroup
                              name="status"
                              id="status"
                              value={fields.status}
                              onChange={handleFieldChangeRadio}
                              row
                            >
                              <FormControlLabel
                                key="Not Confirmed"
                                value="Not Confirmed"
                                control={<Radio size="small" />}
                                label="Not Confirmed"
                                variant="outlined"
                                checked={fields.status == "Not Confirmed" ? true : false}
                              />
                              <FormControlLabel
                                key="Confirmed"
                                value="Confirmed"
                                control={<Radio size="small" />}
                                label="Confirmed"
                                variant="outlined"
                                checked={fields.status == "Confirmed" ? true : false}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid> */}

                      </Grid>
                    </form>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={UpdateApplication} className={[classes.customButton].join(" ")}
                      orientation="vertical"
                      aria-label="vertical contained button group"
                      variant="contained"
                      color="primary"
                      style={{ clear: "both" }}>
                      Save changes
                    </Button>
                  </DialogActions>
                </Dialog>


                {/* Assingnment */}

                <Dialog
                  onClose={handleAssignmentClose}
                  aria-labelledby="customized-dialog-title"
                  open={assignOpen}
                  fullWidth
                  maxWidth="lg"
                >
                  <DialogTitle id="customized-dialog-title" onClose={handleAssignmentClose}>
                    <b
                      className={classes.primary}
                      style={{ textAlign: "center" }}
                    >
                      Confirmation of application submission
                    </b>
                  </DialogTitle>
                  <DialogContent dividers>
                    {applicationsListResponse.success == false &&
                      applicationsListResponse.updatedUser != "" &&
                      fields.fieldStatus == true &&
                      <div className={classes.customFail}>
                        {applicationsListResponse.message}
                      </div>

                    }

                    {
                      applicationsListResponse.success == true &&
                      applicationsListResponse.updatedUser != "" &&
                      fields.fieldStatus == true &&
                      <div className={classes.customSuccess}>
                        {applicationsListResponse.message}
                      </div>

                    }
                    <form >
                      <Grid container item xs={12}>
                        <Typography variant="h6" component="div" gutterBottom style={{ color: "#0d0d0d", position: "relative" }}>
                          Are you sure you want to submit application?Make sure you have provided all the necessary documents and informations for the applicaiton.
                        </Typography>


                      </Grid>
                    </form>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={UpdateStatusApplication} className={[classes.customButton].join(" ")}
                      orientation="vertical"
                      aria-label="vertical contained button group"
                      variant="contained"
                      color="primary"
                      style={{ clear: "both" }}>
                      Submit
                    </Button>
                  </DialogActions>
                </Dialog>


              </div>
            </Grid>
          </Grid>
        }
      </div>
    </>
  );
  
}
